module.exports = __webpack_public_path__ + "img/2017 (2).3534307b.jpg";